module.exports = __webpack_public_path__ + "img/shlk.3c40a7de.jpg";